
import { GridColDef } from "@mui/x-data-grid";


interface ColumnsProps {
    handleVerClick: (uuid: string, link: string) => void;
    urlOrigen?: string;
    rows: any[]; // 🔥 IMPORTANTE: Ahora recibes rows
}

const getColumnsVerificacionAF = ({
    handleVerClick,
    urlOrigen,
    rows
}: ColumnsProps): GridColDef[] => {
    const formatNumber = (value: any) => {
        if (!value) return '';
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const columns: GridColDef[] = [
        {
            field: "municipio",
            headerName: "Municipios",
            width: 150,
            hideable: false,
            headerAlign: "left",
            align: "left",
            renderCell: (cellValues: any) => {
                return <p>{cellValues.row.municipio}</p>;
            },
        },
        {
            field: "HIDROCARBUROS",
            headerName: "Fondo Para Entidades Federativas Y Municipios Productores De Hidrocarburos",
            width: 400,
            hideable: false,
            headerAlign: "left",
            align: "right",
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.row.HIDROCARBUROS)}</p>;
            },
        },
        {
            field: "FISM",
            headerName: "Fondo De Aportaciones Para La Infraestructura Social Municipal",
            width: 400,
            hideable: false,
            headerAlign: "left",
            align: "right",
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.row.FISM)}</p>;
            },
        },
        {
            field: "FORTAMUN",
            headerName: "Fondo Fortalecimiento Para Los Municipios  (FORTAMUN)",
            width: 400,
            hideable: false,
            headerAlign: "left",
            align: "right",
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.row.FORTAMUN)}</p>;
            },
        },
        {
            field: "total_monto",
            headerName: "TOTALES",
            width: 250,
            hideable: false,
            headerAlign: "center",
            align: "right",
            renderCell: (cellValues: any) => {
                return <p>{formatNumber(cellValues.row.total_monto)}</p>;
            },
        },
    ];
    const filteredColumns = columns.filter(col =>
        rows.some(row => row[col.field] !== undefined && row[col.field] !== null)
    );

    return filteredColumns;
};

export default getColumnsVerificacionAF;
